import {getAllDict} from '@/api/admin/dict'

const state = ()=>({
  dictList: []
})

const getters = {
  dictList: state=>state.dictList
}

const actions = {
  getAllDict({commit}) {
    getAllDict().then(res=>{
      let {data} = res.data
      commit('setDictList', data)
    })
  }
}

const mutations = {
  setDictList(state, data) {
    state.dictList = data
  }
}

export default{
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/comm.js